// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__kFDvd","same":"styles_same__z5ix2","description":"styles_description__j+HAA","row":"styles_row__K6XtQ"};